import * as func from './func';

export const updatePosition = (props, state, onChange, key, position, slider) => {
  const values    = func.getValueFromProps(state, props.minValue);
  // const positions = func.getPositionsFromValues(values, props.minValue, props.maxValue, slider);
  const positions = {
    min: func.getPositionFromValue(values.min, props.minValue, props.maxValue, slider),
    max: func.getPositionFromValue(values.max, props.minValue, props.maxValue, slider),
  };
  positions[key]  = position;

  updatePositions(props, state, onChange, positions, slider);
};

const updatePositions = (props, state, onChange, positions, slider) => {
  let values = {
    min: func.getValueFromPosition(positions.min, props.minValue, props.maxValue, slider),
    max: func.getValueFromPosition(positions.max, props.minValue, props.maxValue, slider),
  };
  if (true === props.magnet) {
    Object.keys(values)
      .map(key => {
        if (!props.data.includes(func.getStepValueFromValue(values[key], props.step))) {
          let minValue = null;
          let maxValue = null;
          props.data.map(item => {
            if (item < values[key]) {
              minValue = item;
            }
            if (null === maxValue && item > values[key]) {
              maxValue = item;
            }
          });
          values[key] = maxValue - values[key] <= values[key] - minValue ? maxValue : minValue;
        }
      });
  }
  const transformed = {
    min: func.getStepValueFromValue(values.min, props.step),
    max: func.getStepValueFromValue(values.max, props.step),
  };
  updateValues(props, state, onChange, transformed);
};

const updateValues = (props, state, onChange, values) => {
  if (!shouldUpdate(props, state, values)) {
    return null;
  }
  onChange(func.isMultiValue(state) ? values : values.max);
};

const shouldUpdate = (props, state, values) => isWithinRange(props, state, values) && hasStepDifference(props, state, values);

const isWithinRange = (props, state, values) => {
  if (func.isMultiValue(state)) {
    return values.min <= values.max;
  }

  return values.max >= props.minValue && values.max <= props.maxValue;
};

const hasStepDifference = (props, state, values) => {
  const current = func.getValueFromProps(state, props.minValue);

  return func.length(values.min, current.min) >= props.step || func.length(values.max, current.max) >= props.step;
};